











































import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@/store";
import { Getter, Action } from "vuex-class";
import DashLine from "@/components/common/edit/DashLine.vue";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import getUrlParam from '@/common/utils/getUrlParam';
import DistributeModeExplanation from './DistributeModeExplanation.vue';

@Component({
  components: {
    "activity-label": ActivityLabel,
    "dash-line": DashLine,
    "distribution-mode-explanation": DistributeModeExplanation
  },
})
export default class ActivityDistributeMode extends Vue {
  @Getter('section') section!: any;
  @Action("changeShowFooter") changeShowFooter!: Function;
  @Action('changeSectionDistributeGroupMode') changeSectionDistributeGroupMode!: Function;

  showDistributeModeModal: boolean = false;
  openDistributeModeModal() {
    this.showDistributeModeModal = true;
    this.changeShowFooter(false);
  }
  closeDistributeModeModal() { 
    this.showDistributeModeModal = false;
      this.changeShowFooter(true);
  }
  toggleDistributeMode(type: string) { 
    if (getUrlParam("type") === "reEdit" && getUrlParam("broadcastId")) {
      return;
    }
    this.changeSectionDistributeGroupMode(type)
  }
}
